var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoaded)?_c('div',{attrs:{"id":"Subsidy"}},[_c('Hero',{staticClass:"lift",attrs:{"formats":['webp'],"src":"../../../assets/subsidy-hero.jpg"}},[_c('h1',[_vm._v(_vm._s(_vm.support.title))])]),_c('section',{attrs:{"id":"content"}},[_c('Wrap',[_c('Markdown',{attrs:{"hasStyles":true,"markdown":_vm.support.content}})],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }